import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form } from 'reactstrap';
import { reduxForm } from 'redux-form';
import Loader from '../../../common/Loader';
import FormFooter from '../../../common/forms/FormFooter';
import DynamicForm from '../../../common/forms/DynamicForm';
import { DELIVERY_LOCATION_DISTRICT_COLUMN } from '../../../../config/dynamicFormFields';

export const NewDeliveryLocationDistrictForm = ({ handleSubmit, loading }) => {
  if (loading) return <Loader />;

  const onClickRemove = (index, fields) => {
    fields.remove(index);
  };
  return (
    <Form onSubmit={handleSubmit}>
      <DynamicForm
        name="deliveryDistrict"
        columns={DELIVERY_LOCATION_DISTRICT_COLUMN}
        onClickRemove={onClickRemove}
      />
      <FormFooter />
    </Form>
  );
};

NewDeliveryLocationDistrictForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ CargoUnit }) => ({
  loading: !CargoUnit.DeliveryLocationDistrict.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const formComponent = reduxForm({
  form: 'NewDeliveryLocationDistrictForm',
})(NewDeliveryLocationDistrictForm);

export default connect(mapStateToProps)(formComponent);
